module.exports = __webpack_public_path__ + "static/design04-eb509543c46e20e31a7bc7904d0ceca9.jpg";